import { useEffect } from 'react';

const stack: string[] = [];
let defaultTheme: string | null = null;
let defaultThemeCaptured = false;

function apply(color: string | null) {
  document.body.style.backgroundColor = color ?? '';
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;
  if (color !== null) meta.setAttribute('content', color);
  else if (defaultTheme !== null) meta.setAttribute('content', defaultTheme);
  else meta.removeAttribute('content');
}

export function useBarColor(color: string) {
  useEffect(() => {
    if (!defaultThemeCaptured) {
      const meta = document.querySelector('meta[name="theme-color"]');
      defaultTheme = meta?.getAttribute('content') ?? null;
      defaultThemeCaptured = true;
    }
    stack.push(color);
    apply(color);
    return () => {
      const idx = stack.lastIndexOf(color);
      if (idx >= 0) stack.splice(idx, 1);
      apply(stack.length > 0 ? stack[stack.length - 1] : null);
    };
  }, [color]);
}
